import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewTimeComponentComponent } from './view-time-component.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ViewTimeComponentComponent],
  exports: [ViewTimeComponentComponent]
})
export class ViewTimeComponentModule { }



// WEBPACK FOOTER //
// ./src/app/shared/modules/view-time-component/view-time-component.module.ts